module.exports = __webpack_public_path__ + "img/integralLack.920b1383.png";